import React from 'react';
import { connect } from 'react-redux';
import CustomSnackbar from './CustomSnackBar';
import { hideSnackbar } from './store/action';

interface SnackbarContainerProps {
  message: string;
  open: boolean;
  hideSnackbar: () => void;
}

const SnackbarContainer: React.FC<SnackbarContainerProps> = ({ message, open, hideSnackbar }) => {
  return (
    <CustomSnackbar 
      message={message} 
      open={open} 
      onClose={hideSnackbar} 
    />
  );
};

const mapStateToProps = (state: any) => ({
  message: state.snackbar.message,
  open: state.snackbar.open
});

const mapDispatchToProps = {
  hideSnackbar
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(SnackbarContainer);
